module.exports = __webpack_public_path__ + "img/Pet Supplies.64336153.png";